"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseState = exports.useCurrentOAuthState = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
function useCurrentOAuthState(authRealm) {
    const { pathname, search } = react_router_dom_1.useLocation();
    return react_1.useMemo(() => {
        return authRealm ? serializeState({ authRealm, pathname, search }) : null;
    }, [authRealm, pathname, search]);
}
exports.useCurrentOAuthState = useCurrentOAuthState;
function serializeState(state) {
    return JSON.stringify(state);
}
function parseState(state) {
    return JSON.parse(state);
}
exports.parseState = parseState;
//# sourceMappingURL=useOAuthState.js.map